// import React, { useEffect } from "react";
// import Paper from "@mui/material/Paper";
// import Box from "@mui/material/Box";
// import { styled } from "@mui/material/styles";
// import { Button, TablePagination } from "@mui/material";
// import Grid from "@mui/material/Grid";
// import InputBase from "@mui/material/InputBase";
// import IconButton from "@mui/material/IconButton";
// import SearchIcon from "@mui/icons-material/Search";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import { useState } from "react";
// import AddNewUser from "../AddNewUser";
// import { toast } from "react-toastify";
// import createInstance from "../../../api/axiosinstance";
// import Modal from "../Modal";
// import { useThemeMode } from "../../Themes/ThemeContextTemp.js";


// const UserManagement = () => {
//   const [tabledata, setTableData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [purpose, setPurpose] = useState("");
//   const [viewEditUserId, setViewEditUserId] = useState("");
//   const [openPopup, setOpenPopup] = useState(false);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [actionType, setActionType] = useState("");
//   const aiDishaApi = createInstance("DISHA");
//   const { COLORS } = useThemeMode();
  
//   const organizationId = window.sessionStorage.getItem("organizationId");
//   console.log("ORGID" + organizationId);

//   const fetchTableData = async () => {
//     console.log("orgid", organizationId);
//     try {
//       const response = await aiDishaApi.get(`/get-all-org-users-by-org-id`, {
//         params: { organization_id: organizationId }, // Pass as query params
//       });

//       console.log("Fetched table data:", response.data?.All_users);

//       if (Array.isArray(response.data?.All_users)) {
//         const reversedData = [...response.data.All_users].reverse();
//         setTableData(reversedData);
//         setFilteredData(reversedData);
//       } else {
//         console.error("Unexpected response structure:", response.data);
//         setTableData([]); // Reset to an empty array if data is missing or incorrect
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       toast.error(
//         `Error fetching dataa: ${
//           error.response?.data?.message || error.message
//         }`
//       );
//     }
//   };

//   // Search functionality
//   const handleSearch = (event) => {
//     const query = event.target.value.toLowerCase();
//     setSearchQuery(query);
//     setPage(0); // Reset to first page when searching

//     if (query.trim() === "") {
//       setFilteredData(tabledata); // If empty query, show all data
//     } else {
//       const filtered = tabledata.filter(
//         (user) =>
//           user.full_name.toLowerCase().includes(query) ||
//           user.official_email_id.toLowerCase().includes(query) ||
//           user.mobile_number?.toLowerCase().includes(query) ||
//           user.panelist_id.toLowerCase().includes(query)
//       );
//       setFilteredData(filtered);
//     }
//   };

//   // Add date formatting function

//   const formatDate = (dateString) => {
//     if (!dateString) return "";

//     try {
//       const date = new Date(dateString);

//       if (isNaN(date.getTime())) return ""; // Return empty string for invalid dates

//       // Add padding to ensure two digits

//       const day = date.getDate().toString().padStart(2, "0");

//       const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based

//       const year = date.getFullYear();

//       return `${day}/${month}/${year}`;
//     } catch (error) {
//       console.error("Error formatting date:", error);

//       return "";
//     }
//   };

//   useEffect(() => {
//     fetchTableData();
//   }, []);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const paginatedData = filteredData
//     ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//     : [];

//   const fetchUserDetails = async (panelistId) => {
//     try {
//       const response = await aiDishaApi.get(
//         `/get-org-user-by-panelist-id/${panelistId}`
//       );

//       console.log("user data by id", response.data?.user);

//       return response.data;
//     } catch (error) {
//       console.error(
//         "Error fetching user details:",
//         error.response?.data?.message || error.message
//       );
//       toast.error(
//         `Error fetching user details: ${
//           error.response?.data?.message || error.message
//         }`
//       );
//       return null; // Ensure a return value even in case of failure
//     }
//   };

//   const handleToggleUserStatus = async (panelistId, currentStatus) => {
//     try {
//       // Find the user in the tabledata to get the current status
//       const user = tabledata.find((user) => user.panelist_id === panelistId);
//       if (!user) {
//         toast.error("User not found");
//         return;
//       }

//       // Determine the new status based on the current status
//       const currentStatus = user.status;

//       // Determine the new status based on the current status
//       const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

//       const response = await aiDishaApi.put(
//         `/org-user-status-update/${panelistId}`,
//         {
//           status: newStatus,
//         }
//       );

//       console.log("Response Status:", response.status);
//       console.log("Response Body:", response.data);

//       if (response.status === 200) {
//         toast.success(
//           response.data.message || `User status updated to ${newStatus}`
//         );
//         fetchTableData(); // Refresh table data
//       } else {
//         console.error("Error updating user status:", response.data);
//         toast.error(response.data.message || "Failed to update user status");
//       }
//     } catch (error) {
//       console.error(
//         "Error updating user status:",
//         error.response?.data?.message || error.message
//       );
//       toast.error(
//         `Failed to update user status: ${
//           error.response?.data?.message || error.message
//         }`
//       );
//     }
//   };

//   const handleModalOpen = async (purpose, panelist_id) => {
//     console.log(
//       `Opening modal - Purpose: ${purpose}, Panelist ID: ${panelist_id}`
//     );

//     setViewEditUserId(panelist_id);
//     setPurpose(purpose);
//     setIsModalOpen(true);

//     if (purpose !== "Add") {
//       try {
//         await fetchUserDetails(panelist_id);
//       } catch (error) {
//         console.error("Error in handleModalOpen:", error);
//         toast.error("An error occurred while fetching user details");
//       }
//     } else {
//       setIsModalOpen(true);
//     }
//   };

//   const handleModalClose = () => {
//     setIsModalOpen(false);
//   };

//   const handleopenPopup = (panelist_id) => {
//     // Find the user to get their current status
//     const user = tabledata.find(user => user.panelist_id === panelist_id);
//     if (user) {
//       // Set action type based on current status
//       setActionType(user.status === "Active" ? "deactivate" : "activate");
//     }
//     setOpenPopup(true);
//     setViewEditUserId(panelist_id);
//   };

//   const handleclosepopoup = () => {
//     setOpenPopup(false);
//   };
//   const header = [
//     {
//       userId: "User ID",
//       name: "User Name",
//       gender: "Gender",
//       emailId: "Email ID",
//       mobile: "Mobile",
//       city: "City",
//       role: "Role",
//       joiningDate: "Joining Date",
//       action: "Action",
//       status: "Status",
//     },
//   ];

//   console.log("Modal State:", {
//     openPopup,
//     viewEditUserId,
//     purpose,
//   });

//   return (
//     <div>
//       <Box
//         display="grid"
//         gridTemplateColumns="repeat(12, 1fr)"
//         sx={{
//           marginTop: "auto",
//           alignItems: "center",
//           borderRadius: "10px",
//           padding: "5% 1% 0% 1%",
//         }}
//       >
//         <Box
//           gridColumn="span 12"
//           sx={{
//             marginTop: "auto",
//             textAlign: "left",
//             marginBottom: "2%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Paper
//             sx={{
//               p: "2px 4px",
//               display: "flex",
//               width: "65%",
//               borderRadius: 2,
//               border: "1px solid",
//               background: COLORS.primary,
//             }}
//           >
//             <IconButton type="button" sx={{ p: "8px", color:COLORS.text }} aria-label="search">
//               <SearchIcon />
//             </IconButton>
//             <InputBase
//               sx={{ ml: 1, flex: 1, 
//                 fontFamily: "poppins", 
//                 color: COLORS.text,
//                 "& input::placeholder": {
//                              color: `${COLORS.text} !important`, // 👈 placeholder color
//                              opacity: 10, // important (MUI reduces opacity by default)
//                            },
//                }}
//               placeholder="Search by Name"
//               inputProps={{ "aria-label": "search google maps" }}
//               value={searchQuery}
//               onChange={handleSearch}
//             />
//           </Paper>

//           <Box gridColumn="span 4" sx={{ textAlign: "right" }}>
//             <Button
//               variant="contained"
//               sx={{
//                background: COLORS.button,
//                 color: COLORS.background,
//                 "&:hover": {
//                   background: COLORS.hover_btn,
//                 },
//                 marginRight: "10px",
//                 fontFamily: "poppins",
//               }}
//               onClick={() => handleModalOpen("Add")}
//             >
//               Add New User
//             </Button>
//           </Box>
//         </Box>
//       </Box>

//       <Box xs={1} sx={{ backgroundColor: "#33333" }}>
//         <Grid container spacing={1} sx={{ justifyContent: "center" }}>
//           <Grid item xs={12}>
//             <TableContainer
//               component={Paper}
//               sx={{
//                 marginTop: "25px",
//                 borderRadius: "10px",
//               }}
//             >
//               <Table size="small">
//                 <TableHead sx={{ background: COLORS.primary }}>
//                   {header.map((head) => (
//                     <TableRow key={head.userId}>
//                       <TableCell
//                         sx={{
//                           color: COLORS.text,
//                           borderBottom: 0,
//                           borderLeft: COLORS.secondary,
//                         }}
//                       >
//                         {head.userId}
//                       </TableCell>
//                       <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
//                         {head.name}
//                       </TableCell>

//                       <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
//                         {head.emailId}
//                       </TableCell>
//                       <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
//                         {head.mobile}
//                       </TableCell>

//                       <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
//                         {head.role}
//                       </TableCell>
//                       <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
//                         {head.joiningDate}
//                       </TableCell>
//                       <TableCell sx={{ color:COLORS.text, borderBottom: 0 }}>
//                         {head.status}
//                       </TableCell>
//                       <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
//                         {head.action}
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableHead>
//                 <TableBody sx={{ border: COLORS.secondary }}>
//                   {paginatedData.length > 0 ? (
//                     paginatedData.map((user) => (
//                       <TableRow
//                         key={user.panelist_id}
//                         sx={{
//                           background: COLORS.background,
//                           marginRight: "30px",
//                           border: COLORS.secondary,
//                         }}
//                       >
//                         <TableCell
//                           sx={{ color: COLORS.text, border: COLORS.secondary }}
//                         >
//                           {user.panelist_id}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: COLORS.text, border: COLORS.secondary }}
//                         >
//                           {user.full_name}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: COLORS.text, border: COLORS.secondary }}
//                         >
//                           {user.official_email_id}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: COLORS.text, border: COLORS.secondary }}
//                         >
//                           {user.mobile_number}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: COLORS.text, border: COLORS.secondary }}
//                         >
//                           {user.designation}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: COLORS.text, border: COLORS.secondary }}
//                         >
//                           {formatDate(user.created_date)}
//                         </TableCell>
//                         <TableCell
//                           sx={{ color: COLORS.text, border: COLORS.secondary }}
//                         >
//                           {user.status}
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             color: COLORS.text,
//                             border: COLORS.secondary,
//                             padding: "8px",
//                             height: "100%",
//                           }}
//                         >
//                           <Box
//                             sx={{
//                               display: "flex",
//                               flexDirection: "row",
//                               alignItems: "center",
//                               justifyContent: "flex-start",
//                               gap: "8px",
//                               height: "100%",
//                             }}
//                           >
//                             <Button
//                               variant="contained"
//                               sx={{
//                                 background: COLORS.button_edit_bg,
//                                   "&:hover": {
//                                     background: COLORS.hover_edit_btn,
//                                   },
//                                   color: COLORS.background,
//                                 fontFamily: "poppins",
//                                 height: "24px",
//                                 padding: "2px 8px",
//                                 minWidth: "60px",
//                                 fontSize: "0.75rem",
//                               }}
//                               onClick={() =>
//                                 handleModalOpen("Edit", user.panelist_id)
//                               }
//                             >
//                               Edit
//                             </Button>
//                             <Button
//                               variant="contained"
//                               sx={{
//                                 background: COLORS.button_edit_bg,
//                                   "&:hover": {
//                                     background: COLORS.hover_edit_btn,
//                                   },
//                                   color: COLORS.background,
//                                 fontFamily: "poppins",
//                                 height: "24px",
//                                 padding: "2px 8px",
//                                 minWidth: "60px",
//                                 fontSize: "0.75rem",
//                               }}
//                               onClick={() =>
//                                 handleModalOpen("View", user.panelist_id)
//                               }
//                             >
//                               View
//                             </Button>
//                             <Button
//                               variant="contained"
//                               sx={{
//                                 backgroundColor:
//                                   user.status === "Active"
//                                     ? COLORS.button_red_bg : COLORS.button_green_bg,
//                                 color: COLORS.text,
//                                 fontFamily: "poppins",
//                                 height: "24px",
//                                 padding: "2px 8px",
//                                 minWidth: "90px",
//                                 fontSize: "0.75rem",
//                                  "&:hover": {
//                                     background:
//                                       user.status === "Active"
//                                         ? COLORS.hover_red_btn      // hover when Active (Deactivate button)
//                                         : COLORS.hover_green_btn,   // hover when Inactive (Activate button)
//                                   },

//                               }}
//                               onClick={() => {
//                                 console.log(
//                                   "Deactivate button clicked for:",
//                                   user.panelist_id
//                                 );
//                                 handleopenPopup(user.panelist_id);
//                               }}
//                             >
//                               {user.status === "Active"
//                                 ? "Deactivate"
//                                 : "Activate"}
//                             </Button>
//                           </Box>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   ) : (
//                     <TableRow>
//                       <TableCell
//                         colSpan={8}
//                         align="center"
//                         sx={{ color: "#A7A7A7", padding: "20px" }}
//                       >
//                         {searchQuery
//                           ? "No users match your search criteria"
//                           : "No users found"}
//                       </TableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>
//               <TablePagination
//                 rowsPerPageOptions={[5, 10, 15]}
//                 component="div"
//                 count={tabledata.length}
//                 rowsPerPage={rowsPerPage}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//                 sx={{
//                   background: COLORS.primary,
//                   color: COLORS.text,
//                 }}
//               />
//             </TableContainer>
//           </Grid>
//         </Grid>
//       </Box>
//       <Modal
//         open={openPopup}
//         onClose={handleclosepopoup}
//         title="user"
//         action={() => handleToggleUserStatus(viewEditUserId)}
//         actionType={actionType}
//       />
//       <AddNewUser
//         isOpen={isModalOpen}
//         onClose={handleModalClose}
//         purpose={purpose}
//         viewEditUserId={viewEditUserId}
//         fetchTableData={fetchTableData}
//       />
//     </div>
//   );
// };
// export default UserManagement;
















































import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { Button, TablePagination } from "@mui/material";
import Grid from "@mui/material/Grid";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import AddNewUser from "../AddNewUser";
import { toast } from "react-toastify";
import createInstance from "../../../api/axiosinstance";
import Modal from "../Modal";
import { useThemeMode } from "../../Themes/ThemeContextTemp.js";

const UserManagement = () => {
  const [tabledata, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [purpose, setPurpose] = useState("");
  const [viewEditUserId, setViewEditUserId] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [actionType, setActionType] = useState("");
  const aiDishaApi = createInstance("DISHA");
  const { COLORS } = useThemeMode();

  const organizationId = window.sessionStorage.getItem("organizationId");
  console.log("ORGID" + organizationId);

  const fetchTableData = async () => {
    console.log("orgid", organizationId);
    try {
      const response = await aiDishaApi.get(`/get-all-org-users-by-org-id`, {
        params: { organization_id: organizationId },
      });

      console.log("Fetched table data:", response.data?.All_users);

      if (Array.isArray(response.data?.All_users)) {
        const reversedData = [...response.data.All_users].reverse();
        setTableData(reversedData);
        setFilteredData(reversedData);
      } else {
        console.error("Unexpected response structure:", response.data);
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error(
        `Error fetching data: ${error.response?.data?.message || error.message}`
      );
    }
  };

  // Search functionality
  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
    setPage(0);

    if (query.trim() === "") {
      setFilteredData(tabledata);
    } else {
      const filtered = tabledata.filter(
        (user) =>
          user.full_name.toLowerCase().includes(query) ||
          user.official_email_id.toLowerCase().includes(query) ||
          user.mobile_number?.toLowerCase().includes(query) ||
          user.panelist_id.toLowerCase().includes(query)
      );
      setFilteredData(filtered);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    try {
      const date = new Date(dateString);

      if (isNaN(date.getTime())) return "";

      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedData = filteredData
    ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : [];

  const fetchUserDetails = async (panelistId) => {
    try {
      const response = await aiDishaApi.get(
        `/get-org-user-by-panelist-id/${panelistId}`
      );

      console.log("user data by id", response.data?.user);

      return response.data;
    } catch (error) {
      console.error(
        "Error fetching user details:",
        error.response?.data?.message || error.message
      );
      toast.error(
        `Error fetching user details: ${
          error.response?.data?.message || error.message
        }`
      );
      return null;
    }
  };

  const handleToggleUserStatus = async (panelistId, currentStatus) => {
    try {
      const user = tabledata.find((user) => user.panelist_id === panelistId);
      if (!user) {
        toast.error("User not found");
        return;
      }

      const currentStatus = user.status;
      const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

      const response = await aiDishaApi.put(
        `/org-user-status-update/${panelistId}`,
        {
          status: newStatus,
        }
      );

      console.log("Response Status:", response.status);
      console.log("Response Body:", response.data);

      if (response.status === 200) {
        toast.success(
          response.data.message || `User status updated to ${newStatus}`
        );
        fetchTableData();
      } else {
        console.error("Error updating user status:", response.data);
        toast.error(response.data.message || "Failed to update user status");
      }
    } catch (error) {
      console.error(
        "Error updating user status:",
        error.response?.data?.message || error.message
      );
      toast.error(
        `Failed to update user status: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  // ✅ FIXED: Proper modal opening function
  const handleModalOpen = (purpose, panelist_id) => {
    console.log(
      `Opening modal - Purpose: ${purpose}, Panelist ID: ${panelist_id}`
    );

    setViewEditUserId(panelist_id);
    setPurpose(purpose);
    setIsModalOpen(true); // ✅ Make sure this is set to true

    if (purpose !== "Add") {
      fetchUserDetails(panelist_id);
    }
  };

  // ✅ FIXED: Proper modal closing function
  const handleModalClose = () => {
    setIsModalOpen(false);
    setViewEditUserId("");
    setPurpose("");
  };

  const handleopenPopup = (panelist_id) => {
    const user = tabledata.find((user) => user.panelist_id === panelist_id);
    if (user) {
      setActionType(user.status === "Active" ? "deactivate" : "activate");
    }
    setOpenPopup(true);
    setViewEditUserId(panelist_id);
  };

  const handleclosepopoup = () => {
    setOpenPopup(false);
  };

  const header = [
    {
      userId: "User ID",
      name: "User Name",
      gender: "Gender",
      emailId: "Email ID",
      mobile: "Mobile",
      city: "City",
      role: "Role",
      joiningDate: "Joining Date",
      action: "Action",
      status: "Status",
    },
  ];

  console.log("Modal State:", {
    isModalOpen,
    viewEditUserId,
    purpose,
  });

  return (
    <div>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "5% 1% 0% 1%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{
            marginTop: "auto",
            textAlign: "left",
            marginBottom: "2%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Paper
            sx={{
              p: "2px 4px",
              display: "flex",
              width: "65%",
              borderRadius: 2,
              border: "1px solid",
              background: COLORS.primary,
            }}
          >
            <IconButton
              type="button"
              sx={{ p: "8px", color: COLORS.text }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                fontFamily: "poppins",
                color: COLORS.text,
                "& input::placeholder": {
                  color: `${COLORS.text} !important`,
                  opacity: 10,
                },
              }}
              placeholder="Search by Name"
              inputProps={{ "aria-label": "search google maps" }}
              value={searchQuery}
              onChange={handleSearch}
            />
          </Paper>

          <Box gridColumn="span 4" sx={{ textAlign: "right" }}>
            <Button
              variant="contained"
              sx={{
                background: COLORS.button,
                color: COLORS.background,
                "&:hover": {
                  background: COLORS.hover_btn,
                },
                marginRight: "10px",
                fontFamily: "poppins",
              }}
              onClick={() => {
                console.log("Add New User button clicked");
                handleModalOpen("Add", "");
              }}
            >
              Add New User
            </Button>
          </Box>
        </Box>
      </Box>

      <Box xs={1} sx={{ backgroundColor: COLORS.background }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={12}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ background: COLORS.primary }}>
                  {header.map((head) => (
                    <TableRow key={head.userId}>
                      <TableCell
                        sx={{
                          color: COLORS.text,
                          borderBottom: 0,
                          borderLeft: COLORS.secondary,
                        }}
                      >
                        {head.userId}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {head.name}
                      </TableCell>

                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {head.emailId}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {head.mobile}
                      </TableCell>

                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {head.role}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {head.joiningDate}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {head.status}
                      </TableCell>
                      <TableCell sx={{ color: COLORS.text, borderBottom: 0 }}>
                        {head.action}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody sx={{ border: COLORS.secondary }}>
                  {paginatedData.length > 0 ? (
                    paginatedData.map((user) => (
                      <TableRow
                        key={user.panelist_id}
                        sx={{
                          background: COLORS.background,
                          marginRight: "30px",
                          border: COLORS.secondary,
                        }}
                      >
                        <TableCell
                          sx={{ color: COLORS.text, border: COLORS.secondary }}
                        >
                          {user.panelist_id}
                        </TableCell>
                        <TableCell
                          sx={{ color: COLORS.text, border: COLORS.secondary }}
                        >
                          {user.full_name}
                        </TableCell>
                        <TableCell
                          sx={{ color: COLORS.text, border: COLORS.secondary }}
                        >
                          {user.official_email_id}
                        </TableCell>
                        <TableCell
                          sx={{ color: COLORS.text, border: COLORS.secondary }}
                        >
                          {user.mobile_number}
                        </TableCell>
                        <TableCell
                          sx={{ color: COLORS.text, border: COLORS.secondary }}
                        >
                          {user.designation}
                        </TableCell>
                        <TableCell
                          sx={{ color: COLORS.text, border: COLORS.secondary }}
                        >
                          {formatDate(user.created_date)}
                        </TableCell>
                        <TableCell
                          sx={{ color: COLORS.text, border: COLORS.secondary }}
                        >
                          {user.status}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: COLORS.text,
                            border: COLORS.secondary,
                            padding: "8px",
                            height: "100%",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "8px",
                              height: "100%",
                            }}
                          >
                            <Button
                              variant="contained"
                              sx={{
                                background: COLORS.button_edit_bg,
                                "&:hover": {
                                  background: COLORS.hover_edit_btn,
                                },
                                color: COLORS.background,
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "60px",
                                fontSize: "0.75rem",
                              }}
                              onClick={() => {
                                console.log(
                                  "Edit button clicked for:",
                                  user.panelist_id
                                );
                                handleModalOpen("Edit", user.panelist_id);
                              }}
                            >
                              Edit
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                background: COLORS.button_edit_bg,
                                "&:hover": {
                                  background: COLORS.hover_edit_btn,
                                },
                                color: COLORS.background,
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "60px",
                                fontSize: "0.75rem",
                              }}
                              onClick={() => {
                                console.log(
                                  "View button clicked for:",
                                  user.panelist_id
                                );
                                handleModalOpen("View", user.panelist_id);
                              }}
                            >
                              View
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor:
                                  user.status === "Active"
                                    ? COLORS.button_red_bg
                                    : COLORS.button_green_bg,
                                color: COLORS.text,
                                fontFamily: "poppins",
                                height: "24px",
                                padding: "2px 8px",
                                minWidth: "90px",
                                fontSize: "0.75rem",
                                "&:hover": {
                                  background:
                                    user.status === "Active"
                                      ? COLORS.hover_red_btn
                                      : COLORS.hover_green_btn,
                                },
                              }}
                              onClick={() => {
                                console.log(
                                  "Deactivate button clicked for:",
                                  user.panelist_id
                                );
                                handleopenPopup(user.panelist_id);
                              }}
                            >
                              {user.status === "Active"
                                ? "Deactivate"
                                : "Activate"}
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        sx={{ color: "#A7A7A7", padding: "20px" }}
                      >
                        {searchQuery
                          ? "No users match your search criteria"
                          : "No users found"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={tabledata.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  background: COLORS.primary,
                  color: COLORS.text,
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>

      {/* ✅ FIXED: Modal for deactivate/activate confirmation */}
      <Modal
        open={openPopup}
        onClose={handleclosepopoup}
        title="user"
        action={() => {
          handleToggleUserStatus(viewEditUserId);
          handleclosepopoup();
        }}
        actionType={actionType}
      />

      {/* ✅ FIXED: Add/Edit/View User Modal - Check that AddNewUser is a Modal component */}
      {isModalOpen && (
        <AddNewUser
          isOpen={isModalOpen}
          onClose={handleModalClose}
          purpose={purpose}
          viewEditUserId={viewEditUserId}
          fetchTableData={fetchTableData}
        />
      )}
    </div>
  );
};

export default UserManagement;